/**
 * PriTypingIndicator — Animated 3-dot "thinking" indicator for pRI responses.
 * Pure CSS animation, no external dependencies.
 */

const dotStyle = `
@keyframes pri-bounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
  30% { transform: translateY(-6px); opacity: 1; }
}
`;

export function PriTypingIndicator() {
  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <style>{dotStyle}</style>
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-700 text-sm">
        🤖
      </div>
      <div className="rounded-2xl rounded-bl-md bg-slate-700/60 px-4 py-2.5 dark:bg-slate-700/60">
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-slate-400">pRI gondolkodik</span>
          <div className="flex gap-0.5">
            {[0, 1, 2].map(i => (
              <span
                key={i}
                className="inline-block h-1.5 w-1.5 rounded-full bg-slate-400"
                style={{
                  animation: 'pri-bounce 1.2s ease-in-out infinite',
                  animationDelay: `${i * 0.15}s`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
